import React from 'react';
const MoreButtonSVG = ({ color = 'black', className, onClick }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <g id="Group 1437252927">
        <path
          id="Vector"
          d="M8 21.5H14C19 21.5 21 19.5 21 14.5V8.5C21 3.5 19 1.5 14 1.5H8C3 1.5 1 3.5 1 8.5V14.5C1 19.5 3 21.5 8 21.5Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M14.9965 11.5H15.0045"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M10.9955 11.5H11.0036"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M6.99451 11.5H7.00259"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default MoreButtonSVG;
